import { useUserRewardsMe } from '@/api/user-rewards';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import { useSearchParams } from './useSearchParams';

export function useUserRewardsBySeachParamReward(
  refetchOnMount?: boolean | 'always',
) {
  const search = useSearchParams();
  const rewardId = search.get('reward-id');

  const { isLoading, error, refetch, rewards, reward, ...rest } =
    useUserRewardsMe({
      rewardId: rewardId ? (parseToBigInt(rewardId) as bigint) : undefined,
      refetchOnMount,
    });

  return {
    ...rest,
    rewards,
    isLoading,
    error,
    refetch,
    rewardId,
    reward,
  };
}
